import './MonthlyOutputStyles.css'

import React from 'react';
import { useEffect, useState } from 'react';

import logo from '../../Media/MonthlyOutput/clearloop_logo_noOutline-01.svg';
import carbonIcon from '../../Media/MonthlyOutput/carbon_icon01.svg';

import {app} from '../../firebase/firebaseConfig';
import {getDatabase, ref, onValue} from "firebase/database";


const db = getDatabase(app);


function MontlyOutput(props) {
  // const checkCurrentValue = ref(db, `${props.database}/historicalData`);
  const checkCurrentValue = ref(db, `${props.database}/historicalData`);
  
  //766px breakpont, w100%

  // const [monthData, setMonthData] = useState({
  //   mwh: 0,
  //   lbs: 0
  // })
  let d = new Date();
  const emptyMonths = [
    {
      mwh: 0,
      lbs: 0
    },{
      mwh: 0,
      lbs: 0
    },{
      mwh: 0,
      lbs: 0
    },{
      mwh: 0,
      lbs: 0
    },{
      mwh: 0,
      lbs: 0
    },{
      mwh: 0,
      lbs: 0
    },{
      mwh: 0,
      lbs: 0
    },{
      mwh: 0,
      lbs: 0
    },{
      mwh: 0,
      lbs: 0
    },{
      mwh: 0,
      lbs: 0
    },{
      mwh: 0,
      lbs: 0
    },{
      mwh: 0,
      lbs: 0
    },
  ]
  const [monthArray, setMonthArray] = useState(emptyMonths)
  
  const [yearSelect, setYearSelect] = useState(d.getFullYear())
  const [historicData, setHistoricData] = useState({});
  const [yearlyMWh, setYearlyMWh] = useState(0);
  const [yearlyLbs, setYearlyLbs] = useState(0);
  
  const [overallMWh, setOverallMWh] = useState(0);
  const [overallLbs, setOverallLbs] = useState(0);

  //mwh values for each month
  // let MWhArray =    [0,0,0,0,0,0,0,0,monthData.mwh,0,0,0]
  // let carbonArray = [0,0,0,0,0,0,0,0,monthData.lbs,0,0,0]

  const maxMWhValue = 280;
  const maxCarbonValue = 300000;


  useEffect(()=> {
      onValue(checkCurrentValue, (snapshot) => {
          const data = snapshot.val();
 
          if(JSON.stringify(data) !== JSON.stringify(historicData)){
            setHistoricData(data)          
          }
      })
      createMonthArray()
      createYearOptions()
      createYearTotals()
      // eslint-disable-next-line react-hooks/exhaustive-deps
  },[historicData, yearSelect])

 

  const createMonthArray = () => {
    
    
    let tempYearlyMwh = 0;
    let tempYearlyLbs = 0;

    let tempArray = emptyMonths;
    for (let m in historicData[yearSelect]){         
      if(typeof historicData[yearSelect][m] == 'object' && m < 13){
        tempArray[m] = {
          mwh: historicData[yearSelect][m].mwh,
          lbs: historicData[yearSelect][m].lbs
        }
        tempYearlyMwh += historicData[yearSelect][m].mwh
        tempYearlyLbs += historicData[yearSelect][m].lbs
    }
    }
    setMonthArray(tempArray);

    setYearlyMWh(tempYearlyMwh)
    setYearlyLbs(tempYearlyLbs)
  
}

const createYearTotals = () => {
  let tempOverallMwh = 0;
  let tempOverallLbs = 0;
  for (let y in historicData){
    for (let m in historicData[y]){
      if(typeof historicData[y][m] == 'object' && m < 13){
        tempOverallMwh += historicData[y][m].mwh
        tempOverallLbs += historicData[y][m].lbs
      }
    }
  }
  setOverallMWh(tempOverallMwh)
  setOverallLbs(tempOverallLbs)
}


  const createTopMonths = () => {
    
    let topMonthJSX = []
    let monthCounter = 0
    for(let i of monthArray){
      //change side based om month
      if(i.mwh > 0 && monthCounter >= 6){
      topMonthJSX.push(
        <div className='mwh-bar-filled'style={{height: `${(i.mwh / maxMWhValue) * 100}%`}}>
          <div className='popup-spacer-top-left'></div>
          <div className='mwh-popup mwh-popup-left'>
            <img src={logo} className='small-logo' alt='clearloop logo'></img>
            <p className='popup-text'><strong>{Math.round(i.mwh).toLocaleString()} MWh</strong> solar energy powered in {props.displayName}</p>
          </div>
        </div>
      )
      }else if (i.mwh > 0 && monthCounter < 6) {
        topMonthJSX.push(
        <div className='mwh-bar-filled'style={{height: `${(i.mwh / maxMWhValue) * 100}%`}}>
          <div className='popup-spacer-top-right'></div>
          <div className='mwh-popup mwh-popup-right'>
            <img src={logo} className='small-logo' alt='clearloop logo'></img>
            <p className='popup-text'><strong>{Math.round(i.mwh).toLocaleString()} MWh</strong> solar energy powered in {props.displayName}</p>
          </div>
        </div>
        )
      }else{
        topMonthJSX.push(
          <div className='bar-empty align-btm'></div>
        )
      }
      monthCounter++
    }
    
    return(topMonthJSX)
  }

  const createYearOptions = () => {
    let yearOptions = []
    for(let i in historicData){
      if(i > 2000){
        yearOptions.push(
          <option value={i}>{i}</option>
        )
      }
    }
    yearOptions.reverse()
    return(yearOptions)
  }

  const createBottomMonths = () => {
    let bottomMonthJSX = []
    let monthCounter = 0
    for(let i of monthArray){
      if(i.lbs > 0 && monthCounter >=6){
        bottomMonthJSX.push(
        <div className='lbs-bar-filled'style={{height: `${(i.lbs / maxCarbonValue) * 100}%`}}>
          <div className='popup-spacer-bottom-left'></div>
          <div className='lbs-popup lbs-popup-left'>
            <img src={carbonIcon} className='small-logo' alt='smoke icon'></img>
            <p className='popup-text'><strong>{Math.round(i.lbs).toLocaleString()} lbs</strong> of carbon cleaned from grid powering {props.displayName}</p>
          </div>
        </div>
      )
      }else if (i.lbs > 0 && monthCounter < 6){
        bottomMonthJSX.push(
          <div className='lbs-bar-filled'style={{height: `${(i.lbs / maxCarbonValue) * 100}%`}}>
            <div className='popup-spacer-bottom-right'></div>
            <div className='lbs-popup lbs-popup-right'>
              <img src={carbonIcon} className='small-logo' alt='smoke icon'></img>
              <p className='popup-text'><strong>{Math.round(i.lbs).toLocaleString()} lbs</strong> of carbon cleaned from grid powering {props.displayName}</p>
            </div>
          </div>
        )
      }else{
        bottomMonthJSX.push(
          <div className='bar-empty align-top'></div>
        )
      }
      monthCounter++
    }
    return(bottomMonthJSX)
  }

  

  return (
    <div>
      <h3 id='top-title'>Monthly Solar Output</h3>
      <div className="monthly-output-page-container">
        <div className='top-container'>
          <select className='year-select' onChange={e => {
            setYearSelect(e.target.value)
            }}>
            {createYearOptions()}
            
          </select>
          <h6 className='label-top'><strong>{overallMWh.toLocaleString('en-US', {  minimumFractionDigits: 1, maximumFractionDigits: 1 })} MWh</strong> produced in total <br></br> <strong>{yearlyMWh.toLocaleString('en-US', {  minimumFractionDigits: 1, maximumFractionDigits: 1 })} MWh</strong> produced in {yearSelect}</h6>
          
        </div>


          <div className='bars-container'>
            {createTopMonths()}

          </div>
          <div className='months'>
            <p className='month'>Jan</p>
            <p className='month'>Feb</p>
            <p className='month'>Mar</p>
            <p className='month'>Apr</p>
            <p className='month'>May</p>
            <p className='month'>Jun</p>
            <p className='month'>Jul</p>
            <p className='month'>Aug</p>
            <p className='month'>Sep</p>
            <p className='month'>Oct</p>
            <p className='month'>Nov</p>
            <p className='month'>Dec</p>
          </div>
          <div className='bars-container'>
            {createBottomMonths()}

          </div>
          <h6 className='label-btm'><strong>{overallLbs.toLocaleString('en-US', { maximumFractionDigits: 0 })} lbs</strong> avoided in total <br></br><strong>{yearlyLbs.toLocaleString('en-US', { maximumFractionDigits: 0 })} lbs</strong> avoided in {yearSelect}</h6>
      </div>
      <h3 id='bottom-title'>Monthly Carbon Avoided</h3>
    </div>
  );
}

export default MontlyOutput;
